import { InjectionToken } from '@angular/core';

export interface LifecycleListenerInterface {
  onFirstLoad(): Promise<void>;
}

export const LifecycleListenerInterfaceToken = new InjectionToken<LifecycleListenerInterface>('LifecycleListenerInterface');